import { render } from "./InscriptionsView.vue?vue&type=template&id=2c9da644"
import script from "./InscriptionsView.vue?vue&type=script&lang=js"
export * from "./InscriptionsView.vue?vue&type=script&lang=js"

import "./InscriptionsView.vue?vue&type=style&index=0&id=2c9da644&lang=scss"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__